/*eslint-disable*/ export const messages = JSON.parse("{\"toast.aria.error\":[\"Virhe\"],\"toast.aria.successful\":[\"Onnistui\"],\"toast.aria.warning\":[\"Varoitus\"]}");
//# sourceMappingURL=messages.mjs.map